/**
 * Public Appwrite configuration.
 *
 * These three values are not secrets - a project ID and endpoint are visible to
 * every browser that loads the app, and access is enforced server-side by the
 * `esign-api` function against the caller's JWT. Never add an API key here.
 */
export const APPWRITE_ENDPOINT = 'https://nyc.cloud.appwrite.io/v1';
export const APPWRITE_PROJECT = '69e5a408000ff43aa282';
export const ESIGN_FUNCTION_ID = 'esign-api';

/** Product name, used in headings and the document title. */
export const APP_NAME = 'Better Call Sign';

/** Largest signature PNG the API will accept, in decoded bytes. */
export const MAX_SIGNATURE_BYTES = 2_000_000;
